import type { GetProductionRecordsRequest, ProductionRecord } from "../../types/production-record";
import type { CompanyProductionRecordRepository } from "../../repositories/company/company-production-record-repository";
import type { PageResponse } from "../../../shared/types/common";
import { AppError } from "../../../shared/utils/error-handler";

export class CompanyProductionRecordUseCase {
  constructor(private repository: CompanyProductionRecordRepository) {}

  /**
   * 회사의 생산 실적 목록을 조회합니다.
   */
  async getProductionRecords(request: GetProductionRecordsRequest): Promise<PageResponse<ProductionRecord>> {
    try {
      return await this.repository.getProductionRecords(request);
    } catch (error) {
      throw new AppError(
        String(error) || "생산 실적을 불러오지 못했습니다.",
        "PRODUCTION_RECORDS_GET_FAILED",
        error
      );
    }
  }
}
